import s from "./categoriesFilter.module.css";
import {useCategoriesFilter} from "./useCategoriesFilter";
import {useMediaQuery} from "../../../hooks";
import {CategoriesFormTree, MobileSidebar} from "../../";
import { Fragment, h } from "preact";
import { useAppContext } from "../../../contexts";

/**
 *  The wrapper for the categories filter feature.
 *  It wraps all the cases in which it may be used to, whether it is at desktop or mobile devices.
 * */
const CategoriesFilter = props => {
    // Destructured props
    const {
        availableCategories,
        hiddenTitle,
        handleCatalogCategories
    } = props;

    /**
     * Simple media-query hook to switch between the desktop and mobile forms.
     *
     * This was necessary because there's no way we can do this only with CSS,
     * so everytime the given breakpoint is reached it switches
     * between the mobile and the desktop states.
     * */
    const matches = useMediaQuery('(max-width: 767px)');

    // Component logic data
    const componentProps = useCategoriesFilter({
        availableCategories,
        handleCatalogCategories,
        matches
    });

    // Destructured component logic data
    const {
        data,
        selectedCategories,
        shouldFilter,
        shouldDisplayClearButton,

        collapseController,
        handleCollapseController,

        handleChange,
        handleClear,
        dispatchSyncEvent
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Validates whether the form should be rendered or not
    const form = !matches ? (
        <CategoriesFormTree
            data={data}
            shouldDisplayClearButton={shouldDisplayClearButton}
            handleClear={handleClear}
            handleChange={handleChange}
            selectedCategories={selectedCategories}
            shouldFilter={shouldFilter}

            collapseController={collapseController}
            handleCollapseController={handleCollapseController}
        />
    ) : null;

    return (
        <Fragment>
            <div className={`hidden md:block bg-light-gray rounded-[8px] px-1.5 pt-4 pb-2 ${highContrast ? "grayBackground" : ""}`}>
                <h1 className={`${s.title} ${highContrast ? "highTitleFirst" : ""}`} data-testid="category-filter-title">
                    Filtrar e organizar
                </h1>
                {form}
            </div>

            {/* This is the sidebar that will be only rendered when it's a mobile device */}
            <MobileSidebar
                matches={matches}
                data={data}
                shouldDisplayClearButton={shouldDisplayClearButton}
                handleClear={handleClear}
                hiddenTitle={hiddenTitle}
                handleChange={handleChange}
                selectedCategories={selectedCategories}
                shouldFilter={shouldFilter}

                collapseController={collapseController}
                handleCollapseController={handleCollapseController}
                dispatchSyncEvent={dispatchSyncEvent}
            />
        </Fragment>
    );
};

export default CategoriesFilter;
